import {configureStore} from "@reduxjs/toolkit"
import AuthSlice from "./Components/Redux/Auth/AuthSlice"
import DashboardSlice from "./Components/Redux/Dashboard/DashboardSlice"

const Store=configureStore({
   reducer:{
    AuthSlice,
    DashboardSlice
    
   }
})

export default Store